import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { OtpVerify } from "@/components/site/OtpVerify";

// Email-OTP lookup shared by My Applications and My Orders.
export const EmailLookup = ({ endpoint, onResult, testid }) => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState(null);
  const [busy, setBusy] = useState(false);
  const find = async () => {
    setBusy(true);
    try {
      const r = await api.post(endpoint, { email, verification_token: token });
      onResult(r.data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="max-w-xl space-y-4 rounded-2xl border border-slate-200 bg-white p-6">
      <div className="space-y-1.5">
        <Label htmlFor={`${testid}-email`}>Email address used</Label>
        <Input id={`${testid}-email`} type="email" value={email} onChange={(e) => { setEmail(e.target.value); setToken(null); }} data-testid={`${testid}-email-input`} />
      </div>
      <OtpVerify channel="email" target={email} verified={!!token} onVerified={setToken} testid={`${testid}-otp`} />
      <Button className="rounded-full" disabled={!token || busy} onClick={find} data-testid={`${testid}-find-button`}>Show my records</Button>
      <p className="text-xs text-slate-500">For your privacy we send a one-time code to your email before showing any records.</p>
    </div>
  );
};
